<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Instagram Unofficial Accounts</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Instagram Accounts</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="la la-user"></i> Add Account
                </a>
                <a
                  v-show="false"
                  ref="formBcEdit"
                  class="btn add-btn"
                  @click="showBroadcast(false)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="fa fa-tags"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-6">
              <div class="form-group">
                <multiselect
                  v-model="selectedContact"
                  id="ajax"
                  label="license_name"
                  track-by="id"
                  :placeholder="'Type to search Brand...'"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabel"
                  :options="contactOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  @search-change="asyncFind"
                  :show-labels="false"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{option.name}}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      class="multiselect__clear"
                      v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.username" type="text" />
                <label class="focus-label">Username</label>
              </div>
            </div>

            <!-- <div class="col-sm-6 col-md-6">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.description" type="text" />
                <label class="focus-label">Description</label>
              </div>
            </div>-->

            <div class="col-sm-6 col-md-3">
              <a
                href="javascript:void(0)"
                @click.prevent="searchData"
                class="btn btn-success btn-block"
              >Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionUpdateStatus('logout')"
                  :disabled="isLoading"
                  class="btn btn-warning btn-block"
                >
                  <i class="fa fa-sign-out"></i>Logout
                </button>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionUpdateStatus('relogin')"
                  :disabled="isLoading"
                  class="btn btn-success btn-block"
                >
                  <i class="fa fa-sign-in"></i> Re-Login
                </button>
              </div>
            </div>
            <div class="col-sm-2 col-md-2">
              <div class="form-group">
                <button
                  @click.prevent="actionDelete"
                  :disabled="isLoading"
                  class="btn btn-danger btn-block"
                >
                  <i class="fa fa-trash"></i> Delete
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th rowspan="2">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th class="text-center" rowspan="2">Brand</th>
                      <th class="text-center" rowspan="2">Username</th>
                      <th class="text-center" rowspan="2">Login Status</th>
                      <th class="text-center" colspan="7">Statistics</th>
                      <th class="text-center" rowspan="2">Last Modified</th>
                      <th class="text-center" rowspan="2">Actions</th>
                    </tr>
                    <tr>
                      <th class="text-wrap">Total Following</th>
                      <th class="text-wrap">Total Followers</th>
                      <th class="text-wrap">Total Posts</th>
                      <th class="text-wrap">Total Like</th>
                      <th class="text-wrap">Total Play</th>
                      <th class="text-wrap">Total Comments</th>
                      <th class="text-wrap">Engagement Rate (%)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="14">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row,index) in rows" :key="index">
                        <td>
                          <div class="checkbox">
                            <label>
                              <input type="checkbox" v-model="selectedTable" :value="row.id" />
                            </label>
                          </div>
                        </td>
                        <td class="text-wrap" :ref="'id-'+row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td class="text-wrap">
                          <a
                            target="_blank"
                            :href="'https://www.instagram.com/'+row.username"
                          >{{row.username}}</a>
                        </td>
                        <td class="text-wrap">
                          <div v-if="row.login_status==1">
                            <span class="badge badge-success">Connected</span>
                            <br />
                            <small
                              class="text-muted"
                            >Last Login: {{timeAgo(row.login_update_datetime)}}</small>
                            <br />
                          </div>
                          <div v-else-if="row.login_status==2">
                            <span class="badge badge-info">Connecting...</span>
                          </div>
                          <span v-else class="badge badge-danger">Not Connected</span>
                          <div v-if="row.login_status==0" class="text text-danger">
                            <small>{{row.login_reason}}</small>
                          </div>
                        </td>
                        <td class="text-right">{{row.total_following}}</td>
                        <td class="text-right">{{row.total_followers}}</td>
                        <td class="text-right">{{row.total_post}}</td>
                        <td class="text-right">{{row.total_like}}</td>
                        <td class="text-right">{{row.total_play}}</td>
                        <td class="text-right">{{row.total_comment}}</td>
                        <td class="text-right">{{row.total_engagement_rate}}</td>
                        <td class="text-wrap">{{formatLocalDate(row.update_datetime)}}</td>
                        <td>
                          <div class="dropdown action-label">
                            <a
                              class="btn btn-white btn-sm btn-rounded dropdown-toggle"
                              href="#"
                              data-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa fa-dot-circle-o text-danger"></i> Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <a @click.prevent="detailData(row.id)" class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>
                              <a @click.prevent="copyData(row.id)" class="dropdown-item">
                                <i class="fa fa-copy text-info"></i> Copy
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length<1 && !loading">
                      <tr>
                        <td colspan="14" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="'btn '+{
                    disabled:
                      parseInt(currentPage) + 1 >
                      Math.ceil(totalRecords / serverParams.perPage)
                  }"
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data :searchData="searchData" />

    <!-- {{selectedContact}} -->
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import FormData from "./form.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import { formatLocalDate, timeAgo } from "@/utils/helper";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    Multiselect,
  },
  data() {
    return {
      selectedTable: [],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        name: "",
        page: 0,
        perPage: 20
      },
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        official_api_status: "0",
        brand_id: "",
        username: "",
        page: 1,
        perPage: 20 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedContact = val;
        }
        if (val.length == 1) {
          this.serverParams.brand_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.brand_id = "";
          this.searchData();
        }
      },
      deep: true
    }
  },
  created() {
    this.asyncFind("");
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(actionValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to " +
          actionValue +
          " " +
          this.selectedTable.length +
          " accounts?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: actionValue
              // status: statusValue
            };
            this.$store
              .dispatch("instagramAccount/actionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success " + actionValue,
                  text: "The data was successfully " + actionValue,
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("instagramAccount/actionStored", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ name }) {
      return `${name}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.name = query;
      this.$store
        .dispatch("brand/list", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    clearAll() {
      this.selectedContact = [];
    },
    async copyData(id) {
      //set false dulu
      this.$store.dispatch("instagramAccount/setIsShowForm", false);
      let formData = await {};
      await this.$store
        .dispatch("instagramAccount/detailEdit", id) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = data;
        });
      console.log("formData::", formData);
      formData.copy = true;
      await this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    async detailData(id) {
      //set false dulu
      this.$store.dispatch("instagramAccount/setIsShowForm", false);
      let formData = await {
        copy: false,
        id: "",
        brand_id: [],
        brand_selected: [],
        ig: {
          id: "",
          username: "",
          password: ""
        }
      };
      await this.$store
        .dispatch("instagramAccount/detailEdit", id) // sesuai kan dengan method di API
        .then(async response => {
          var { data } = response;
          // console.log("response::", response);
          // console.log("data::", data);

          formData = data;
          // formData.brand_id = [];
          // await data.brand_selected.forEach((row, idx) => {
          //   formData.brand_id[idx] = row.brand_id;
          //   console.log("formData.brand_id::", formData.brand_id, row.brand_id);
          // });
          // console.log("formData::", formData);
        });
      // console.log("formData::", formData);
      formData.id = id;
      formData.ig.id = id;
      await this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },

    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("instagramAccount/setIsShowForm", false);

        let formData = {
          brand_id: [],
          ig: {
            id: "",
            username: "",
            password: ""
          },
          brand_selected: []
        };
        this.$store.dispatch("instagramAccount/actFormParamSt", formData);
      }
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("instagramAccount/setIsShowForm", true);
        }
      }, 1000);
    },

    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      await this.$store
        .dispatch("instagramAccount/list", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          // console.log("rows", this.rows);
          this.loading = false;
          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              // let detailId = row.brand_id;
              this.$store
                .dispatch("instagramAccount/detailEdit", row.id) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  // console.log("resData", resData.brand_selected);
                  this.$refs["id-" + row.id][0].innerHTML = "";
                  resData.brand_selected.forEach((rowDet, idx) => {
                    if (idx > 0) {
                      this.$refs["id-" + row.id][0].innerHTML +=
                        ", " + rowDet.name;
                    } else {
                      this.$refs["id-" + row.id][0].innerHTML += rowDet.name;
                    }
                    // console.log("name", rowDet.name);
                  });
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/instagram/instagramAccount/list.vue